var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCouponRemove = function SvgCouponRemove(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40 40"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "coupon-remove_svg__a",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#000",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "coupon-remove_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#coupon-remove_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    mask: "url(#coupon-remove_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.834 5.106 1.06 1.06L6.166 18.894l-1.06-1.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.894 17.834-1.06 1.06L5.106 6.166l1.06-1.06z"
  }))))));
};
export default SvgCouponRemove;